import React, { useState, useEffect } from 'react'
import useLogin from '../hooks/useLogin'
import Button from '@material-ui/core/Button'
import CssBaseline from '@material-ui/core/CssBaseline'
import TextField from '@material-ui/core/TextField'
import Link from '@material-ui/core/Link'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import logoSpotter from '../images/login-spotter-logo.png'
import loginBackground from '../images/login-background-primary.png'
import CircularProgress from '@material-ui/core/CircularProgress'
import ShowPasswordIcon from '../images/show-password.svg'
import HidePasswordIcon from '../images/hide-password.svg'

function Copyright() {
  return (
    <Typography variant="body2" align="center" style={{ color: '#304968' }}>
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Spotter
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  )
}

export default function SignIn() {
  const classes = useStyles()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [submit, setSubmit] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const loginRequest = useLogin(email, password, submit)
  useEffect(() => {
    if (
      !loginRequest.isLoading &&
      submit &&
      (loginRequest.data || loginRequest.error)
    ) {
      setSubmit(false)
    }
  }, [loginRequest.isLoading, loginRequest.error, submit])

  return (
    <Container component="main" className={classes.fullWidth}>
      <CssBaseline />
      <div className={classes.container}>
        <div
          style={{
            backgroundImage: `url(${loginBackground})`,
            backgroundSize: 'cover',
            width: '56vw',
            height: '100vh',
            backgroundPosition: 'center',
          }}
        ></div>
        <div className={classes.paper}>
          <div className={classes.imageContainer}>
            <img
              src={logoSpotter}
              width="232px"
              height="42px"
              alt="spotter"
            ></img>
            <Typography component="h1" variant="h5" className={classes.title}>
              Iniciar sesión
            </Typography>
          </div>
          <div className={classes.form}>
            <Typography component="body2" className={classes.fieldLabel}>
              Usuario
            </Typography>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="email"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(evt) => {
                setEmail(evt.target.value)
              }}
              onKeyDown={(e) => e.key === 'Enter' && setSubmit(true)}
              className={classes.formField}
              InputProps={{
                className: classes.input,
              }}
            />
            <Typography component="body2" className={classes.fieldLabel}>
              Contraseña
            </Typography>
            <div className={classes.passwordWrapper}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="password"
                type={showPassword ? 'text' : 'password'}
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(evt) => {
                  setPassword(evt.target.value)
                }}
                onKeyDown={(e) => e.key === 'Enter' && setSubmit(true)}
                className={classes.formField}
                InputProps={{
                  className: classes.input,
                }}
              />
              <img
                src={showPassword ? HidePasswordIcon : ShowPasswordIcon}
                alt="copy to clipboard"
                width="16px"
                height="13px"
                className={classes.showHidePassword}
                onClick={() => setShowPassword(!showPassword)}
              ></img>
            </div>
            {loginRequest.error && (
              <span style={{ color: 'red', fontSize: '20px' }}>
                {loginRequest?.error || 'Ah ocurrido un error.'}
              </span>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={() => {
                setSubmit(true)
              }}
            >
              {loginRequest.isLoading ? <CircularProgress /> : 'Ingresar'}
            </Button>
          </div>
          <Box mt={8}>
            <Copyright />
          </Box>
        </div>
      </div>
    </Container>
  )
}

const useStyles = makeStyles((theme) => ({
  fullWidth: {
    maxWidth: '100%',
    paddingLeft: 0,
    paddingRight: 0,
  },
  container: {
    display: 'flex',
  },
  paper: {
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  imageContainer: {
    width: '366px',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    display: 'flex',
    color: '#3068F9',
    fontSize: '20px',
    margin: '32px 0',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '366px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  submit: {
    width: '366px',
    height: '53px',
    borderRadius: '12px',
    margin: theme.spacing(3, 0, 2),
    '&:hover': {
      backgroundColor: '#3068F9',
    },
  },
  fieldLabel: {
    fontSize: '13px',
    color: '#868686',
    marginBottom: '4px',
  },
  formField: {
    borderRadius: '12px',
    marginBottom: '16px',
  },
  input: {
    borderRadius: '12px',
    color: '#304968',
  },
  passwordWrapper: {
    width: '100%',
    position: 'relative',
  },
  showHidePassword: {
    cursor: 'pointer',
    position: 'absolute',
    right: '16px',
    top: '22px',
  },
  '@global': {
    'input:-webkit-autofill': {
      '-webkit-box-shadow': '0 0 0 1000px white inset !important',
      'box-shadow': '0 0 0 1000px white inset !important',
      '-webkit-text-fill-color': '#304968 !important',
      'text-fill-color': '#304968 !important',
    },
  },
}))
